import React from 'react';

import PropTypes from 'prop-types';

import Skeleton from '@asteria/component-core/skeleton';
import { TooltipWrapper } from '@asteria/component-core/tooltip';
import { Text, TextGroup, Title } from '@asteria/component-core/typography';

import { TranslationService } from '@asteria/language';

import { useHeaderData } from './hooks';

import './styles.scss';

const ForecasterHeaderTextGroup = React.memo((props) => {
	const { onSubmit } = props;

	const { translationData, query } = useHeaderData({ onSubmit });

	if (query?.isFetching) {
		return (
			<div className="flex flex-col items-end gap-4">
				<Skeleton size="md" className="w-72" animated />
				<Skeleton className="w-40" animated />
			</div>
		);
	}

	return (
		<TooltipWrapper
			tooltip={TranslationService.get(
				['forecaster.header.overview.tooltip'],
				undefined,
				translationData,
			)}
		>
			<TextGroup className="asteria-component__text-amount">
				<Text>
					{TranslationService.get(
						['forecaster.header.account'],
						undefined,
						translationData,
					)}
				</Text>
				<Title size="xs">
					{TranslationService.get(
						'forecaster.header.total',
						undefined,
						translationData,
					)}
				</Title>
			</TextGroup>
		</TooltipWrapper>
	);
});

ForecasterHeaderTextGroup.propTypes = {
	onSubmit: PropTypes.func,
};

ForecasterHeaderTextGroup.displayName = 'ForecasterHeaderTextGroup';

export default ForecasterHeaderTextGroup;
